export default [
  {
    name: "dashboard",
    children: [
      {
        name: "levelinfolist",
        path: "/manage/flightpolicy/levelinfolist",
        component: (resolve) => require(["./levelinfo/levelinfolist.vue"], resolve),
      },
      {
        name: "levelinfoupdate",
        path: "/manage/flightpolicy/levelupdate",
        component: (resolve) => require(["./levelinfo/levelinfoupdate.vue"], resolve),
      },
      // {
      //   name: "bigcustomerlist",
      //   path: "/manage/bigcustomer/list",
      //   component: (resolve) => require(["./bigcustomer/list.vue"], resolve),
      // },
      {
        name: "bigcustomerdetail",
        path: "/manage/bigcustomer/detail",
        component: (resolve) => require(["./policy/bigcustomer.vue"], resolve),
      },
      {
        name: "PolicyDetails",
        path: "/manage/flightCN/policys",
        component: (resolve) => require(["./policy/policys.vue"], resolve),
      },
      {
        name: "salepolicy",
        path: "/manage/salepolicy/list",
        component: (resolve) => require(["./salepolicy/list.vue"], resolve),
      },
      {
        name: "salepolicydetial",
        path: "/manage/salepolicy/detail",
        component: (resolve) => require(["./salepolicy/salepolicy.vue"], resolve),
      },
      {
        name: "flightRobotList",
        path: "/manage/flight/robot/list",
        component: (resolve) => require(["./robot/list.vue"], resolve),
      },
      {
        name: "flightRobotInfo",
        path: "/manage/flight/robot/detail",
        component: (resolve) => require(["./robot/detail.vue"], resolve),
      },
      {
        name: "ibeCount",
        path: "/manage/flight/ibeCount",
        component: (resolve) => require(["./ibeCount.vue"], resolve),
      },
      {
        path: "/manage/companyunion/list",
        component: (resolve) => require(["./union/list.vue"], resolve),
      },
    ],
  },
];



// WEBPACK FOOTER //
// ./src/views/manage/flightCN/router.js